import request from '@/common/request';
/**
 * 待服务订单,列表
 */
export function PendingServiceOrder(data) {
  return request({
    url: '/clinic/order/pendingServiceOrder',
    method: 'GET',
    params: data
  });
}

/**
 * 待服务订单，确认收款
 */
export function ConfirmedPaid(data) {
  return request({
    url: '/clinic/order/confirmedPaid',
    method: 'POST',
    data
  });
}

/***
 * 待服务订单，详情
 */
export function GetOrderDetail(data) {
  return request({
    url: '/clinic/order/pendingServiceOrderDetail',
    method: 'GET',
    params: data
  });
}

/**
 * 待服务订单，核对完成
 */
export function CheckCompletionService(data) {
  return request({
    url: '/clinic/order/checkCompletionService',
    method: 'POST',
    data
  });
}
/**
 * 订单详情
 **/
export function GetOrderDetailInfo(data) {
  return request({
    url: '/clinic/order/detail',
    method: 'GET',
    params: data
  });
}


